import authHeader from './auth-header';
import Api from './api';
import { JobStatus } from 'app/models/jobstatus';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class JobTrackerService {  
  async jobStatus(jobid: string) : Promise<JobStatus> {
    return (await Api().get(`${API_URL}/jobtracker/status/${jobid}`, { headers:  authHeader() as any })).data;
  }
}

export default new JobTrackerService();